export const QUESTION_STATUSES = {
	DRAFT: "DRAFT",
	ANSWERED: "ANSWERED",
	SENT: "SENT",
	FROM_COMPETITION: "FROM_COMPETITION",
	TRASH: "TRASH",
};
